
import SupplierCategory_017035 from './SupplierCategory_017035'
import ApiCheckSupplyName11900 from './ApiCheckSupplyName11900'
import ApiMerchantsSettle11080 from './ApiMerchantsSettle11080'
import ApiFirstPagePersonList17264 from './ApiFirstPagePersonList17264'
import ApiCheckSupplyNameForSubmit25752 from './ApiCheckSupplyNameForSubmit25752'
import ApiMerchantsSettle25780 from './ApiMerchantsSettle25780'
import ApiCheckSupplyName25787 from './ApiCheckSupplyName25787'
import ApiFindCategoryManager25745 from './ApiFindCategoryManager25745'
import ApiEmployeeSmsSend28735 from './ApiEmployeeSmsSend28735'
import ApiEmployeeQuery28875 from './ApiEmployeeQuery28875'
import ApiEmployeeSmsLogin28742 from './ApiEmployeeSmsLogin28742'
import ApiEmployeeGraphGet28728 from './ApiEmployeeGraphGet28728'
import CategoryNo60874 from './NewSupplierCategoryGetCategoryConfigRespByCategoryNo60874'
import NewSupplierCategoryCategoryNo36890 from './NewSupplierCategoryCategoryNo36890'

export default {
  SupplierCategory_017035,
  ApiCheckSupplyName11900,
  ApiMerchantsSettle11080,
  ApiFirstPagePersonList17264,
  ApiCheckSupplyNameForSubmit25752,
  ApiMerchantsSettle25780,
  ApiCheckSupplyName25787,
  ApiFindCategoryManager25745,
  ApiEmployeeSmsSend28735,
  ApiEmployeeQuery28875,
  ApiEmployeeSmsLogin28742,
  ApiEmployeeGraphGet28728,
  CategoryNo60874,
  NewSupplierCategoryCategoryNo36890
}

